export default __webpack_public_path__ + "static/media/team.4282398f.jpg";